import { render, staticRenderFns } from "./WizardPermissionStep.vue?vue&type=template&id=de196532&"
import script from "./WizardPermissionStep.vue?vue&type=script&lang=js&"
export * from "./WizardPermissionStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de196532')) {
      api.createRecord('de196532', component.options)
    } else {
      api.reload('de196532', component.options)
    }
    module.hot.accept("./WizardPermissionStep.vue?vue&type=template&id=de196532&", function () {
      api.rerender('de196532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/WizardPermissionStep.vue"
export default component.exports